import React, { useState } from 'react';
import { TinyMCEInput } from '@wajeez-web/components/ui';
import { Modal } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { CommonModalProps } from './Types';

const AnswerContactUsModal: React.FC<CommonModalProps<{ q: string }>> = ({
  isOpen,
  onClose,
  onSubmit,
  data,
}) => {
  const [answer, setAnswer] = useState('');

  return (
    <Modal
      title={'FAQ Modal'}
      open={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <div className=" space-y-2">
        <div className=" font-semibold text-slate-800 flex  space-s-1">
          {data && data.q}
          <ReturnTranslatedText text={`general.?`} />
        </div>
        <TinyMCEInput
          name="answer"
          value={answer}
          onChange={(name, val) => setAnswer(val)}
          label={'answer'}
        />
      </div>
    </Modal>
  );
};

export default AnswerContactUsModal;
